import { render, staticRenderFns } from "./cardDesc.vue?vue&type=template&id=52f263d6&scoped=true&"
import script from "./cardDesc.vue?vue&type=script&lang=js&"
export * from "./cardDesc.vue?vue&type=script&lang=js&"
import style0 from "./cardDesc.vue?vue&type=style&index=0&id=52f263d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f263d6",
  null
  
)

export default component.exports